<template>
<div >
  <div class="form-group">
    <label for="brand"><strong>MARCHIO</strong></label>
      <input @change="$emit('update',brand)" list="brandList" autocomplete="off" :required="required" v-focus ref="brand"  class="form-control bold"  id="brands" name="brands" v-model="brand">
        <datalist id="brandList">              
          <option v-for="(item,index) in items" :key="index">{{item.brand}} </option>        
        </datalist>
  </div>  
</div>

</template>
<script>
import api             from "@/api";

export default {
  props : ['supplierId','required','_brand'] , 
  components: {},
  data() {
    return {
      brand                  : this._brand ? this._brand : '',
      items                  : [],
      spinner                : false
     
    };
  },
   directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  mounted: function() {
  
  },
  created: function() {
      if(this.supplierId)
      {
        this.getData()
      }
  },
  methods: 
  {
    async getData()
    {
            
      var sp   = {'sp'         : 'spSupplierBrandList'}      
      var data = {'supplierId' : this.supplierId}
      var json  = Object.assign(data, sp)
      
      

      await api.post(json).then(res => {
          
         
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]   
              
              


            }
           else if(res.status==500)
           {
                console.log(res.data)
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });
    
 



     
    },
  
    
    
  
}

}
</script>
<style scoped>

</style>